import type { WhatsAppSendErrorCode } from "../whatsappTypes";

const KNOWN = new Set<WhatsAppSendErrorCode>([
  "ventana_cerrada",
  "confirmacion_costo",
  "plantillas_deshabilitadas",
  "limite_envios",
  "envio_fallido",
  "sin_configuracion",
  "desconocido",
]);

/** i18n key of the user-facing message of a send error code. */
export const sendErrorMessageKey = (code: WhatsAppSendErrorCode) =>
  `crm.whatsapp.conversation.send_errors.${code}`;

/** Maps a server `code` (or anything else) to a typed send error code. */
export const toWhatsAppSendErrorCode = (
  serverCode: unknown,
): WhatsAppSendErrorCode =>
  typeof serverCode === "string" &&
  KNOWN.has(serverCode as WhatsAppSendErrorCode)
    ? (serverCode as WhatsAppSendErrorCode)
    : "desconocido";

/** Error thrown by both data providers for a refused or failed WhatsApp send. */
export class WhatsAppSendError extends Error {
  code: WhatsAppSendErrorCode;
  constructor(code: WhatsAppSendErrorCode) {
    super(sendErrorMessageKey(code));
    this.name = "WhatsAppSendError";
    this.code = code;
  }
}
